export default "__VITE_ASSET__CCPS1hST__"